import { getHttpClient } from 'src/http-client';
import { AutomationRuleType } from './types/automation-rule';
const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

export async function getAutomationRuleListByFilterService(args: {
  organizationName: string;
  projectId: string;
  filter: {
    createdBy?: string;
    status?: string;
  }
}): Promise<Array<AutomationRuleType> | null> {
	try {
		const httpClient = getHttpClient();
		const response = await httpClient.get(`${apiUrl}/automations/${args.organizationName}/${args.projectId}`, {
			params: args.filter,
			headers: {
				'Content-Type': 'application/json'
			}
		});
  
		if (response.status === 200) {
			return response.data.automations as Array<AutomationRuleType>;
		}
  
		return null;
	} catch (err) {
		console.log(err);
		throw new Error('Get automation rule list service.');
	}
}